import { FormLabel, Grid, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';

const BrokerageAddressField = ({ field, canEdit = true }) => {
	const { getFieldProps } = useFormikContext();
	const fieldProps = getFieldProps(field);

	return (
		<Grid size={6} key={field}>
			<FormLabel>
				{field
					.replace(/([a-z])([A-Z])/g, '$1 $2')
					.replace(/(^\w|\s\w)/g, (c) => c.toUpperCase())}
			</FormLabel>
			<TextField fullWidth disabled={!canEdit} {...fieldProps} />
		</Grid>
	);
};

export default BrokerageAddressField;
